import React, { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { setUserAppSettings } from "@/modules/hub/features/UserAppSettings/slices/userAppSettingsSlice";
import { markPreEpWelcomeSeen } from "../../api/markPreEpWelcomeSeen";
import { usePreEpChecklist } from "../../hooks/usePreEpChecklist";
import PreEpSteps from "../PreEpSteps/PreEpSteps";
import PreEpWelcomeIntro from "../PreEpWelcomeIntro/PreEpWelcomeIntro";

/**
 * A Pre-EP member's home: the welcome intro on their first visit, then the
 * getting-started checklist.
 */
const PreEpStepsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const settings = useAppSelector(
    (state) => state.userAppSettings.userAppSettings,
  );
  const [playing, setPlaying] = useState(settings?.showPreEpWelcome === true);
  const { checklist, markExternalDone } = usePreEpChecklist();
  const firstName = settings?.firstName ?? "";

  const handleIntroDone = useCallback(() => {
    setPlaying(false);
    if (settings) {
      dispatch(setUserAppSettings({ ...settings, showPreEpWelcome: false }));
    }
    void markPreEpWelcomeSeen();
  }, [dispatch, settings]);

  return (
    <>
      {playing && (
        <PreEpWelcomeIntro firstName={firstName} onDone={handleIntroDone} />
      )}
      <PreEpSteps
        checklist={checklist}
        firstName={firstName}
        onOpenExternal={markExternalDone}
      />
    </>
  );
};

export default PreEpStepsPage;
